module.exports = __webpack_public_path__ + "img/lk-phone.63d51bbb.svg";